import React from 'react';
import { useNavigate } from 'react-router-dom';
import { UserCircle } from 'lucide-react';
import './PortalButton.css';

const PortalButton = () => {
  const navigate = useNavigate();

  return (
    <div className="fab-container">
      <button className="portal-fab" onClick={() => navigate('/portal')}>
        <span className="fab-text">Portal</span>
        <UserCircle size={24} strokeWidth={2.5} />
        <div className="pulse-ring"></div>
      </button>
    </div>
  );
};

// YEH LINE SABSE IMPORTANT HAI:
export default PortalButton;